var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddConfigActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4921 0.0977917C14.3596 0.14193 14.1498 0.329508 14.0173 0.495018C13.7854 0.792936 13.7854 0.815004 13.7854 7.28094V13.78H7.27055H0.755725L0.424463 14.0779C-0.249103 14.6848 -0.0945143 15.8323 0.700515 16.1633C1.00969 16.2957 2.1912 16.3178 7.43618 16.3178H13.7854V22.8389V29.36L14.1056 29.68C14.3816 29.9559 14.5141 30 15 30C15.4859 30 15.6184 29.9559 15.8944 29.68L16.2146 29.36V22.8389V16.3178H22.5638C27.8088 16.3178 28.9903 16.2957 29.2995 16.1633C30.0945 15.8323 30.2491 14.6848 29.5755 14.0779L29.2443 13.78H22.7295H16.2146V7.29198C16.2146 0.175032 16.2478 0.506052 15.5521 0.152964C15.1988 -0.0346165 14.8454 -0.0456505 14.4921 0.0977917Z",
    fill: "#8C2148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConfigActive);
export default __webpack_public_path__ + "static/media/addConfigActive.831d79f9f65ca130074646ad7dc592ad.svg";
export { ForwardRef as ReactComponent };